import { BroadcastChannel as L } from "broadcast-channel";
import { useRef as d, useCallback as a, useEffect as v } from "react";
import { useDebouncedCallback as H } from "use-debounce";
const K = {
  delay: 500,
  leading: !0,
  maxWait: 1e3
}, D = 30 * 1e3, E = "useTrackIdleTimeGlobally", I = `${E}_lastActiveTimeInMs`, N = [
  "mousemove",
  "keydown",
  "wheel",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "visibilitychange",
  "focus"
], k = ({ lastActiveTime: l }) => {
  localStorage.setItem(I, String(l));
}, O = (l, s) => {
  s == null || s.postMessage(l).catch(console.error);
};
function p({
  onIdle: l,
  onActive: s,
  onPrompt: A,
  pause: R = !1,
  idleTimeoutInMs: r = null,
  promptTimeoutInMs: u,
  messageConfig: Y
}) {
  if (r !== null && r < D * 2)
    throw new Error("idleTimeoutInMs cannot be less than 60 seconds");
  if (r && u && u >= r)
    throw new Error("promptTimeoutInMs must be less than idleTimeoutInMs");
  const t = R || !r, c = d(
    t ? null : new L(E)
  ), g = d(
    parseInt(localStorage.getItem(I) ?? "") || null
  ), i = d(null), n = d(null), { delay: B, ...V } = { ...K, ...Y }, h = H(
    ({ lastActiveTime: e }) => {
      O({ lastActiveTime: e }, c == null ? void 0 : c.current);
    },
    B,
    V
  ), f = a(
    ({
      readStorage: e,
      lastActiveTime: b
    } = {
      readStorage: !1,
      lastActiveTime: null
    }) => {
      if (t)
        return;
      const C = b ?? g.current, y = (b ?? e) && C ? Date.now() - C : 0, x = setTimeout(() => {
        l();
      }, r - y);
      if (i.current = x, g.current = Date.now(), A) {
        const G = u ? r - u : r - D;
        n.current = setTimeout(() => {
          A(), n.current && clearTimeout(n.current);
        }, G - y);
      }
    },
    [r, l, A, t, u]
  ), o = a(() => {
    i != null && i.current && (clearTimeout(i.current), i.current = null), n != null && n.current && (clearTimeout(n.current), n.current = null);
  }, []), m = a(
    (e) => {
      o(), f(e);
    },
    [o, f]
  ), w = a(
    (e) => {
      o(), !t && (s(), m(e), k(e));
    },
    [o, t, s, m]
  ), T = a(() => {
    if (o(), t)
      return;
    s(), m();
    const e = { lastActiveTime: Date.now() };
    k(e), h(e);
  }, [o, h, t, s, m]), S = a(() => {
    N.forEach((e) => {
      document.addEventListener(e, T);
    });
  }, [T]), _ = a(() => {
    N.forEach((e) => {
      document.removeEventListener(e, T);
    });
  }, [T]);
  v(() => {
    if (!t)
      return f({ readStorage: !0 }), () => {
        o();
      };
  }, [o, t, f]), v(() => {
    if (!t)
      return S(), () => {
        _();
      };
  }, [S, t, _]), v(() => {
    if (!t)
      return c.current || (c.current = new L(E)), c.current.onmessage = (e) => {
        e != null && e.lastActiveTime && w({ lastActiveTime: e.lastActiveTime });
      }, () => {
        var e;
        (e = c.current) == null || e.close().catch(console.error).finally(() => {
          c.current = null;
        });
      };
  }, [w, t]);
}
export {
  N as ACTIVITY_EVENTS,
  E as BROADCAST_CHANNEL_KEY,
  I as LAST_ACTIVE_TIME_IN_MS_KEY,
  p as useTrackIdleTimeGlobally
};
//# sourceMappingURL=useTrackIdleTimeGlobally.js.map
